import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import AppHeader from "../AppHeader";

export default function PublicLayout() {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Box
        sx={(theme) => ({
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          backgroundColor: theme.palette.background.default,
          color: "text.primary",
        })}
      >
        <AppHeader />
        <Outlet />
      </Box>
    </Box>
  );
}
